import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { VirtualVendor, VirtualVendorQuotaUpdate } from '@api/models/dashboard';
import { Observable } from 'rxjs';

/**
 * Virtual-store vendors.
 * Admin API: GET/PATCH /stores/{storeId}/vendors/virtual (base already includes /api/v1).
 */
@Injectable({
  providedIn: 'root',
})
export class VirtualVendorsData extends ApiServiceBase<VirtualVendor> {
  constructor() {
    super('stores', 'evoqAdmin');
  }

  fetchVirtualVendors(storeId: string): Observable<VirtualVendor[]> {
    return this.customRequest<VirtualVendor[]>({ method: 'GET', url: `${storeId}/vendors/virtual` });
  }

  updateVirtualQuotas(storeId: string, updates: VirtualVendorQuotaUpdate[]): Observable<VirtualVendor[]> {
    return this.customRequest<VirtualVendor[]>({
      method: 'PATCH',
      url: `${storeId}/vendors/virtual`,
      body: updates,
    });
  }
}
